import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Instantly scrolls the viewport to the top whenever the route pathname changes.
 * If the target URL contains a hash (e.g. #core-areas), we skip scrolling so
 * the browser can scroll to the anchor instead.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
